import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose, branch, renderComponent } from 'recompose'
import { Link } from 'react-router'
import { fromJS, Map } from 'immutable'

import { isIntegrationConnected } from 'utils/Integrations'
import {
  fetchAssistantOrgSettings,
  fetchSalesforceSettings,
  handleEditConfig,
} from 'app/modules/assistantSettings/actions'
import {
  assistantOrgSettings,
  isEditingMapping,
  isEditingActivity,
} from 'app/modules/assistantSettings/selectors'
import {
  hasCustomizedAssistantSFDCMapping,
  hasCustomizedAssistantSFDCActivity,
} from 'app/modules/org/selectors'

import PageTitle from 'components/shared/PageTitle'
import { SectionItem } from 'components/shared/Section'

import AssistantOrgSalesforceConnect from './AssistantOrgSalesforceConnect'
import AssistantConfigSalesforceMapping from './AssistantConfigSalesforceMapping'
import AssistantConfigSalesforceActivity from './AssistantConfigSalesforceActivity'

import styles from './style.styl'

const defaultConfigSettings = fromJS({
  salesforceLeadObject: 'LEAD',
  salesforceEventObject: 'EVENT',
  sfLeadFields: Map(),
  sfEventFields: Map(),
  followUpWithOpenOps: true,
})
class AssistantConfigOrg extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      salesforceMappingOutOfSync: false,
      salesforceActivityOutOfSync: false,
    }
  }
  componentDidMount() {
    this.props.actions.fetchOrgSettings()
    this.props.actions.fetchSalesforceSettings()
  }

  handleEditMapping = ({ isEditingValue, isSFDCOutOfSyncValue }) => {
    this.setState({ salesforceMappingOutOfSync: isSFDCOutOfSyncValue })
    this.props.actions.handleEditConfig({ settingName: 'MAPPING', value: isEditingValue })
  }

  handleEditActivity = ({ isEditingValue, isSFDCOutOfSyncValue }) => {
    this.setState({ salesforceMappingOutOfSync: isSFDCOutOfSyncValue })
    this.props.actions.handleEditConfig({ settingName: 'ACTIVITY', value: isEditingValue })
  }

  render() {
    const {
      orgSettings,
      hasCustomizedAssistantSFDCMapping,
      hasCustomizedAssistantSFDCActivity,
      isEditingMapping,
      isEditingActivity,
    } = this.props
    const { salesforceMappingOutOfSync, salesforceActivityOutOfSync } = this.state
    const hasCompletedOnboarding = hasCustomizedAssistantSFDCMapping && hasCustomizedAssistantSFDCActivity

    return (
      <div className={styles.AssistantConfigOrg}>
        <Link to="/settings2/assistant" className="assistant-nav-link">
          {'< View my Drift Assistant'}
        </Link>
        <PageTitle
          title="The Drift Assistant"
          description="The Drift Assistant will match how your team identifies qualified leads and demos held. That way, your team is only reminded about the right people at the right time."
          className="assistant-config-title"
        />
        {!hasCompletedOnboarding && (
          <SectionItem
            title="Configure the Drift Assistant for your Team"
            description="Make sure your team never lets a lead or opportunity fall through the cracks again. Help them succeed by configuring your team's Drift Assistant with your Salesforce account below."
            className="assistant-educational-banner"
          />
        )}
        <SectionItem
          title="Send reminders for the leads that matter most"
          description="The Drift Assistant will only send reminders to your team about people who match the following Salesforce mapping. For example, you can configure the assistant so your team only receives meeting reminder emails for people who are qualified leads."
        >
          <AssistantConfigSalesforceMapping
            orgSettings={salesforceMappingOutOfSync ? defaultConfigSettings : orgSettings}
            isEditing={isEditingMapping || !hasCustomizedAssistantSFDCMapping}
            handleEdit={this.handleEditMapping}
            hasPassedOnboarding={hasCustomizedAssistantSFDCMapping}
            salesforceOutOfSync={salesforceMappingOutOfSync}
          />
        </SectionItem>
        <SectionItem
          title="Send reminders after a demo&rsquo;s been held"
          description="When the Drift Assistant sends a reminder for your team to follow up after a meeting, it’ll use Salesforce to make sure the demo’s been held. Customize what the Drift Assistant uses to identify a held demo below."
        >
          <AssistantConfigSalesforceActivity
            orgSettings={salesforceActivityOutOfSync ? defaultConfigSettings : orgSettings}
            isEditing={isEditingActivity || !hasCustomizedAssistantSFDCActivity}
            handleEdit={this.handleEditActivity}
            hasPassedOnboarding={hasCustomizedAssistantSFDCActivity}
            salesforceOutOfSync={salesforceActivityOutOfSync}
          />
        </SectionItem>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isSalesforceConnected: isIntegrationConnected('salesforce'),
  orgSettings: assistantOrgSettings(state),
  hasCustomizedAssistantSFDCMapping: hasCustomizedAssistantSFDCMapping(state),
  hasCustomizedAssistantSFDCActivity: hasCustomizedAssistantSFDCActivity(state),
  isEditingMapping: isEditingMapping(state),
  isEditingActivity: isEditingActivity(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchOrgSettings: fetchAssistantOrgSettings,
      fetchSalesforceSettings,
      handleEditConfig,
    },
    dispatch
  ),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  branch(props => !props.isSalesforceConnected, renderComponent(AssistantOrgSalesforceConnect))
)(AssistantConfigOrg)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfigOrg/index.js